module.exports = __webpack_public_path__ + "media/images/icons/flags/GH-a8fa97093391051a6efcb9e8ca1ba5cc.svg";